import { render, staticRenderFns } from "./RegistrationStepTwoCompany.vue?vue&type=template&id=07acae0c&scoped=true&"
import script from "./RegistrationStepTwoCompany.vue?vue&type=script&lang=js&"
export * from "./RegistrationStepTwoCompany.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationStepTwoCompany.vue?vue&type=style&index=0&id=07acae0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07acae0c",
  null
  
)

export default component.exports